import { url } from "inspector";
import React, { useState, useEffect } from "react";
import { Button, Container, Dropdown, Nav, Navbar, NavDropdown } from "react-bootstrap";
import { isMobile } from "../utils";
import { Bars, Close } from "./icons";
import { Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import menuList from "../routes/menu";
import { ProfileScore } from "./profileScore";
import { setProfileScore } from "../redux/actions";


const MenuLayout = function () {
    const user = useSelector((state: any) => state.appReducer.userInfo) || {};
    const menus = menuList;
    const location = useLocation();

    const filteredMenus = menuList.filter(item => item.label !== "Logout");

    const isTabSelected = (path: string) => {
        return location.pathname === path;
    };
    return (
        <Nav className="menu-horizontal">
            {filteredMenus.map((value: any, key: number) => {
                if (value.showOnLogin && !Object.keys(user).length) {
                    return null;
                }

                if (value.label) {
                    const Icon = value.icon;
                    const isSelected = isTabSelected(value.path);
                    const tabClass = isSelected ? 'nav-link-header selected' : 'nav-link-header';
                    return (
                        <Nav.Item key={key}>

                            <Link className={tabClass} to={value.path}>
                                {Icon && <Icon className="icon-class" />}
                                {value.label}
                            </Link>
                        </Nav.Item>
                    );
                }
                return null;
            })}
        </Nav>
    );
};



const REACT_APP_MYXALARY_URL = ''// "https://notchhr.io/";
export default function Header() {
    const location = useLocation();
    const navigate = useNavigate();
    const url = process.env.REACT_APP_MYXALARY_URL || REACT_APP_MYXALARY_URL;
    const mobile = isMobile();
    const { email, firstName, lastName, profileImageUrl } = useSelector((state: any) => state.appReducer.userInfo);

    const profileScore = useSelector((state: any) => state.appReducer.profileScore);
    const dispatch = useDispatch();
    const isLoggedIn = Boolean(email);
    const [showMenu, setShowMenu] = useState<boolean>(false);
    const features: any = {
        "Clock-in By MyXalary": "/clock-in.html",
        "Requisition": "/requisition.html",
        "Time Tracker": "/time-tracker.html",
        "Payroll": "/payroll.html",
        "Attendance Management": "/attendance.html",
        "Leave Management": "/attendance.html"
    }
    const howitworks: any = {
        "CEO's/Co-Founders": "/ceo.html",
        "HR Managers": "/hr-manager.html",
        "Work from Home/ Remote Teams": "/remote-workers.html",
        "Employees": "/employee.html",
    }

    useEffect(() => {
        const savedScore = localStorage.getItem('profileScore');
        if (savedScore !== null) {
            dispatch(setProfileScore(parseInt(savedScore)));
        }
    }, [dispatch]);


    const Menu = React.memo(() => {
        return <>

            <Nav className="d-flex justify-content-center" style={{ width: "80%", }} activeKey="/home">
                <Nav.Item >
                    <Nav.Link className="link" href={`${url}`}>Home</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                    <Nav.Link className="link" href={`${url}about-us.html`}>About Us</Nav.Link>
                </Nav.Item>
                <NavDropdown
                    id="nav-dropdown-dark-example"
                    title="Features"
                    className="link"
                >
                    {
                        Object.keys(features).map((value: any, key: number) => {
                            return <NavDropdown.Item href={`${url}${features[value]}`} key={key}>{value}</NavDropdown.Item>
                        })
                    }
                </NavDropdown>
                <Nav.Item>
                    <Nav.Link className="link" href={`/`}>Jobs</Nav.Link>
                </Nav.Item>
                <NavDropdown
                    id="nav-dropdown-dark-example"
                    title="How it works"
                    className="link"
                >
                    {
                        Object.keys(howitworks).map((value: any, key: number) => {
                            return <NavDropdown.Item href={`${url}${howitworks[value]}`} key={key}>{value}</NavDropdown.Item>
                        })
                    }
                </NavDropdown>
                <Nav.Item>
                    <Nav.Link className="link" href={"https://notchhr.io/blog/"}>blog</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                    <Nav.Link className="link" href={`${url}frequently-ask-questions.html`}>FAQs</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                    <Nav.Link className="link" href={`${url}contact.html`}>Contact us</Nav.Link>
                </Nav.Item>
            </Nav>
        </>
    })

    const renderLoginHeader = () => (
        <div className="new-login-header-div">
            <div className="new-login-header">
                <div className="new-login-text">Login</div>
                <div className="new-login-btn-div">
                    <Link className="btn btn-purple" to="/signup">Don't have an account? Sign Up</Link>
                </div>
            </div>
            <hr />
        </div >


    );

    const renderSignupHeader = () => (
        <div>
            <div className="new-login-header">
                <div className="new-login-text">SignUp</div>
                <div className="new-login-btn-div">
                    <Link className="btn-pink-login" to="/login">Already have an account? Login</Link>
                </div>
            </div>
            <hr />
        </div>
    );


    const renderLogOutHeader = () => (
        <div className='header-log-out bg-white shadow-sm'>
            <Navbar.Brand href="https://notchhr.io"><div className="logo"></div></Navbar.Brand>
            <div className="auth-buttons">
                <Link className=" log-out-login" to="/login">Login</Link>
                <Link className="btn btn-purple" to="/signup">Sign Up</Link>
            </div>
        </div>
    );

    const renderMainHeader = () => (
        <div className=" bg-white shadow-sm main-header-div ">
            <div className='header-top'>
                <Navbar.Brand href="https://notchhr.io"><div className="logo"></div></Navbar.Brand>
                <button className="logout-button" onClick={() => navigate('/logout')}>Logout</button>
            </div>
            <hr />
            <div className="big-div-header-btn d-flex">

                <div className=" menu-and-btns1">
                    <MenuLayout />
                </div>
                <div className="menu-and-btns2">
                    {isLoggedIn && (
                        <div className="header-user-actions">
                            <ProfileScore score={profileScore} />

                            {profileScore < 100 && (
                                <div className="btn-profile-action">
                                    <button className="btn-profile-action" onClick={() => navigate('/my-profile')} >
                                        Complete your profile
                                    </button>

                                </div>
                            )}

                            <div className="profile-picture">

                                <div className="user-details">
                                    <span className="user-name">
                                        {firstName && lastName ? `${firstName} ${lastName}` : email}
                                    </span>
                                </div>
                            </div>

                        </div>
                    )}

                </div>

            </div>
        </div >
    );


    const determineHeader = () => {
        if (location.pathname === '/login') {
            return renderLoginHeader();
        } else if (location.pathname === '/signup') {
            return renderSignupHeader();
        } else {
            return isLoggedIn ? renderMainHeader() : renderLogOutHeader();
        }
    };

    return (
        <>
            {determineHeader()}

        </>
    );
}

